import Navbar from '../navbar';
import Footer from '../footer';
import WhatsAppFloatingButton from '../floating-button/whatsAppFloatingButton';
import { JSX } from 'react';

interface IProps {
	children: JSX.Element | JSX.Element[];
	className?: string;
	hideFooter?: boolean;
}

export default function Screen({ children, className, hideFooter }: IProps) {
	return (
		<div className={`w-full h-full bg-base-100 text-base-content good-times ${className}`}>
			<Navbar/>
			{children}
			{!hideFooter && <Footer/>}
			<WhatsAppFloatingButton/>
		</div>
	);
}